<template>
    <div>
        <div class="qMsgMarkBox">
            <div class="title">快捷回复</div>
            <!-- <div style="margin-top: 10px;">
                <el-tabs v-model="activeQMsgName" @tab-click="qMsgClick">
                    <el-tab-pane :label="v.typeName" v-for="(v, i) in tabList" :name="'qmsg' + i" :key="i"></el-tab-pane>
                </el-tabs>
            </div> -->
            <div style="margin-top: 10px;">
                <div v-if="loading" class="loading-box">
                    <i class="el-icon-loading loading-icon"></i>
                    <span class="loading-text">加载中...</span>
                </div>
                <template v-else>
                    <div class="editBox" v-for="(v, i) in dataList" :key="i">
                        <template v-if="!v.state">
                            <input class="lmyLeft" type="text" readonly v-model="v.description">
                            <div>
                                <!-- <i class="el-icon-edit" @click="edtiFun(v, i)"></i> -->
                                <i class="el-icon-delete ml10" @click="delFun(v, i)"></i>
                            </div>
                        </template>
                        <template v-else>
                            <input class="lmyLeft" type="text" v-model="editVal" @keyup.enter="editSuccessFun(v, i)">
                            <div><i class="el-icon-check" @click="editSuccessFun(v, i)"></i><i class="el-icon-close ml10"
                                    @click="cancelFun()"></i></div>
                        </template>
                    </div>

                    <div class="editBox" v-if="isAdd">
                        <input class="lmyLeft" type="text" v-model="editVal" @keyup.enter="createFun()">
                        <div><i class="el-icon-check" @click="createFun()"></i><i class="el-icon-close ml10"
                                @click="isAdd = false"></i>
                        </div>
                    </div>
                    <div class="addBox" v-else><el-button type="primary" icon="el-icon-circle-plus-outline"
                            @click="addFun">添加</el-button>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { getConversationStarterList, deleteConversationStarter, createConversationStarter } from '@/api/talkytimes/message'

export default {
    props: {
        isShow: {
            type: Boolean,
            default: false
        },
        chatUserInfo: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {
            activeQMsgName: 'qmsg0',
            dataList: [],
            editVal: '',
            isAdd: false,
            tabList: [],//分类数据
            checkType: '',//用户选择的分类信息
            checkData: '',//用户选择的修改的消息信息
            isLoading: false, // 防止重复提交
            loading: false, // 新增：列表加载动画
        };
    },
    watch: {
        isShow: {
            handler(newVal) {
                console.log(newVal)
                if (newVal) {
                    // 获取组别
                    this.getQuickMessageList()
                }
            },
            immediate: true  // 立即以当前值触发回调
        }
    },
    methods: {
        // 获取类型下的数据
        getQuickMessageList() {
            this.loading = true; // 新增：开始加载
            this.dataList = [];
            getConversationStarterList({
                idLast: 0,
                limit: 15
            }).then(res => {
                this.dataList = []
                let data = res.data
                if (data.length > 0) {
                    this.dataList = data.map((item, index) => {
                        // 当前点击项设为true，其他所有项设为false
                        return {
                            ...item,
                            state: false
                        };
                    });
                } else {
                    this.dataList = [];
                }
            }).finally(() => {
                this.loading = false; // 新增：加载结束
            })
        },
        addFun() {
            this.isAdd = true;
            this.cancelFun();
        },
        delFun(v) {
            console.log(v.id, typeof(v.id))
            console.log({ id: v.id })
            deleteConversationStarter({
                id: v.id
            }).then(res => {
                this.$message.success('删除成功');
                this.getQuickMessageList()
                // if (res.code == 200) {
                    
                // } else {
                //     this.$message.error('删除失败')
                // }
            })
        },
        // 提交编辑
        editSuccessFun() {
            console.log(this.editVal);
            if (!this.editVal) {
                this.$message.error('请填写您要修改的内容')
                return;
            }
            if (this.isLoading) {
                console.log(this.isLoading, '正在加载，阻止加载')
                return
            }
            this.isLoading = true;
            editQuickMessage({
                platformType: this.chatUserInfo.platformType,
                platformUserId: this.chatUserInfo.platformUserId,
                typeId: this.checkType.recId,
                recId: this.checkData.recId,
                message: this.editVal
            }).then(res => {
                this.$message.success('修改成功');
                this.getQuickMessageType()
            }).finally(() => {
                this.isLoading = false;
                console.log(this.isLoading, 'isLoading')
            })
        },
        // 编辑快捷消息
        edtiFun(v, i) {
            this.editVal = v.description;
            this.checkData = v;
            this.dataList = this.dataList.map((item, index) => {
                // 当前点击项设为true，其他所有项设为false
                return {
                    ...item,
                    state: i === index
                };
            });
        },
        cancelFun() {
            this.dataList = this.dataList.map((item, index) => {
                // 当前点击项设为true，其他所有项设为false
                return {
                    ...item,
                    state: false
                };
            });
            console.log(this.dataList)
        },
        qMsgClick(tab) {
            this.checkType = this.tabList[tab.index]
            console.log(this.checkType)
            this.getQuickMessageList()
        },
        createFun() {
            console.log(this.editVal);
            if (!this.editVal) {
                this.$message.success('请填写快捷消息内容');
                return
            }
            if (this.isLoading) {
                console.log(this.isLoading, '正在加载，阻止加载')
                return
            }
            this.isLoading = true;
            createConversationStarter({
                description: this.editVal
            }).then(res => {
                this.$message.success('添加成功');
                this.isAdd = false
                this.getQuickMessageList()
            }).finally(() => {
                this.isLoading = false;
                console.log(this.isLoading, 'isLoading')
            })
        },
    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
.qMsgMarkBox {
    .title {
        font-size: 20px;
        font-weight: 600;
        text-align: center;
    }

    .editBox {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 40px;
        border-bottom: 1px solid #eeeeee;

        .lmyLeft {
            width: 700px;
            // border-right: 1px solid #000;
            height: 100%;
            border: none;
            background-color: transparent;
            outline: none;
        }

        .ml10 {
            margin-left: 10px;
        }
    }

    .addBox {
        width: 100%;
        margin-top: 10px;
        display: flex;
        justify-content: center;
    }
}
.loading-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 120px;
  color: #409EFF;
  font-size: 16px;
}
.loading-icon {
  font-size: 32px;
  margin-bottom: 8px;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>